// src/components/common/Badge.jsx
import React from "react";

/**
 * Clean Badge Component (NO animation)
 *
 * Props:
 * - children: text
 * - tone: "admin" | "organiser" | "sponsor" | "rider"
 *          "success" | "info" | "danger" | "muted"
 * - size: "sm" | "md" | "lg"
 * - icon: optional React element (SVG, Lottie, etc.)
 * - className, style
 */
export default function Badge({
  children,
  tone = "muted",
  size = "md",
  icon = null,
  className = "",
  style = {},
}) {
  const sizeMap = {
    sm: { padding: "0.18rem 0.5rem", fontSize: 12, radius: 12, gap: 6 },
    md: { padding: "0.32rem 0.75rem", fontSize: 13, radius: 14, gap: 8 },
    lg: { padding: "0.42rem 1rem", fontSize: 15, radius: 16, gap: 10 },
  };

  const s = sizeMap[size] || sizeMap.md;

  const toneColors = {
    // Role badges
    admin: { bg: "#F8E8C7", fg: "#7A5900" },
    organiser: { bg: "#FFE7C9", fg: "#9A4A00" },
    sponsor: { bg: "#D7F7F7", fg: "#067A73" },
    rider: { bg: "#DDF6EA", fg: "#0D7B4A" },

    // System badges
    danger: { bg: "#FEE2E2", fg: "#991B1B" },
    success: { bg: "#D1FAE5", fg: "#065F46" },
    info: { bg: "#E0E7FF", fg: "#3730A3" },
    muted: { bg: "#F3F4F6", fg: "#111827" },
  };

  const c = toneColors[tone] || toneColors.muted;

  return (
    <span
      className={`badge-root inline-flex items-center ${className}`}
      style={{
        background: c.bg,
        color: c.fg,
        padding: s.padding,
        fontSize: s.fontSize,
        borderRadius: s.radius,
        gap: s.gap,
        boxShadow: "0 3px 8px rgba(0,0,0,0.04)",
        border: "1px solid rgba(0,0,0,0.04)",
        lineHeight: 1,
        ...style,
      }}
    >
      {icon && (
        <span
          className="badge-icon"
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginRight: 6,
          }}
        >
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
